/**
 * @module constants/ApplicationStateKeys
 */

export const ApplicationStateKeys = Object.freeze({
  /* flag set after initialization workflow has completed */
  APPLICATION_INITIALIZED: 'APPLICATION_INITIALIZED',

  /* app determined to have lost network connection */
  IS_OFFLINE: 'IS_OFFLINE',

  /* last action taken while app was determined to be offline */
  LAST_OFFLINE_ACTION: 'LAST_OFFLINE_ACTION',

  /* number of service errors experienced consecutively */
  SERVICE_ERRORS: 'SERVICE_ERRORS',

  /* flag indicating API calls are currently not being sent */
  IS_BUFFERING_API_CALLS: 'IS_BUFFERING_API_CALLS',

  /* flag indicating current page is 404 page */
  IS_404_PAGE: 'IS_404_PAGE',

  /* path to pass to coachmark */
  COACHMARK_PATH: 'COACHMARK_PATH',

  /* tab Id representing the currently playing tab */
  XTAB_CURRENTLY_PLAYING_TAB_ID: 'XTAB_CURRENTLY_PLAYING_TAB_ID',

  /* tab Id representing this tab */
  XTAB_MY_TAB_ID: 'XTAB_MY_TAB_ID',

  /* flag indicating whether we are currently writing to local storage on store updates */
  IS_PERSISTING_LOCALLY: 'IS_PERSISTING_LOCALLY',

  /* map of query parameters, key/value */
  STARTUP_QUERY_PARAMETERS: 'STARTUP_QUERY_PARAMETERS',

  /* flag indicating if the user is in the process of logging out */
  IS_LOGGING_OUT: 'IS_LOGGING_OUT',

  /* flag indicating current page is premium playlist page */
  IS_PLAYLIST_PAGE: 'IS_PLAYLIST_PAGE',

  IS_MOBILE_WEB: 'IS_MOBILE_WEB',

  IS_TABLET_DEVICE: 'IS_TABLET_DEVICE',

  DEVICE_ID: 'DEVICE_ID',
} as const);
